/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../models/sales_tax_entry';
import '../../../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "GetSalesTaxEntriesRequest": {
                    "fields": {}
                  },
                  "GetSalesTaxEntriesResponse": {
                    "fields": {
                      "salesTaxEntries": {
                        "type": ".squareup.sfs.models.SalesTaxEntry",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "errors": {
                        "type": ".squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.GetSalesTaxEntriesRequest && !$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.GetSalesTaxEntriesResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Request to retrieve sales tax entries for a merchant
 * --
 *
 * SOURCE GetSalesTaxEntriesRequest @ squareup/sfs/external/services/tax/get_sales_tax_entries.proto at 11:1
 */
export const GetSalesTaxEntriesRequest = $root.lookupType('squareup.sfs.external.service.GetSalesTaxEntriesRequest');
fixType(GetSalesTaxEntriesRequest);
Builder.createAndAttachToType(GetSalesTaxEntriesRequest);
/**
 * SOURCE GetSalesTaxEntriesResponse @ squareup/sfs/external/services/tax/get_sales_tax_entries.proto at 17:1
 */
export const GetSalesTaxEntriesResponse = $root.lookupType('squareup.sfs.external.service.GetSalesTaxEntriesResponse');
fixType(GetSalesTaxEntriesResponse);
Builder.createAndAttachToType(GetSalesTaxEntriesResponse);